import joinRouter from './modules/join';
import { RouteConfig } from 'vue-router';

const routes: RouteConfig[] = [...joinRouter];

export default routes;
